export default __webpack_public_path__ + "static/media/bars.b53c07b0.svg";